import {
  IAuthClaims,
  type DocumentReference,
  type Timestamp,
} from '@principle-theorem/shared';
import { type IRole } from '../auth/role';
import { type IBrand } from '../brand';
import { type IPractice } from '../practice/practice';

export interface IUserMetadata {
  firstSignedInAt?: Timestamp;
  lastSignInTime?: Timestamp;
  lastActiveAt?: Timestamp;
}

export enum MultifactorOverride {
  Required = 'required',
  Disabled = 'disabled',
}

export interface IUser extends IUserMetadata {
  name: string;
  phone: string;
  email: string;
  profileImageURL?: string;
  multifactorOverride?: MultifactorOverride;
  roles: DocumentReference<IRole>[];
  practices: DocumentReference<IPractice>[];
  brands: DocumentReference<IBrand>[];
  isEnabled: boolean;
}

export interface IPrincipleAuthClaims extends IAuthClaims {
  partnerUids: string[];
  enabledPartnerUids: { [key: string]: boolean };
  orgUserDocIds: { [orgUid: string]: string };
}
